<template>
    <div id="customOrganizationPage" class="login-container" :style="getBackgroundCss">
        <div class="forgot-password-panel">
            <div class="forgot-password-title">
                <span v-text="title"></span>
                <img src="../../../assets/images/x-icon-grey.svg" alt="X" @click="actionBackToLogin">
            </div>
            <div class="forgot-password-desc" v-text="description"></div>
            <text-input label="E-mail" :init-value="email" ref="email"/>
            <text-button label="Submit" :loading-state="loadingState" @click="actionSubmit"/>
            <need-you-help/>
        </div>
    </div>
</template>

<script>
    import ForgotPassword from "@/old/pages/ForgotPassword";
    import customLoginPageMixin from "@/new/pages/OrganizationLogin/customLoginPageMixin";

    export default {
        name: "ForgotPassword",
        mixins: [ForgotPassword, customLoginPageMixin],
        methods: {
            /**
             * Using router name not from enum because params work only with named routes!
             * https://router.vuejs.org/guide/essentials/navigation.html
             */
            actionBackToLogin() {
                this.$router.push({
                    name: 'CustomOrganizationLoginPage',
                    params: {organization: this.$route.params.organization}
                });
            }
        }
    }
</script>

<style scoped>

</style>
